<template>
  <Form :model="formData" label-position="top" :rules="rules">
    <BaseSegment title="产品信息"   desc="产品的基础信息"  :disabled="true">

           <Row>
             <Col :span="6">
              <FormItem label="产品图片" prop="avatar">
                <div class="flex-wrap flex-center"  style="width:calc(100% - 20px);height:200px;border:1px solid var(--border);border-radius:5px;">
             <GFormImageClip v-model="formData.avatar" :editable="true"
            :option="{
              uploader:'session/upload'
            }"/>
              </div>
             </FormItem>
            </Col>
            <Col :span="18">
            <Row :gutter="20">

            <Col :span="10">
              <FormItem required label="分类" prop="type_id">
                <Select v-model="formData.type_id" clearable filterable transfer>
                  <OptionGroup v-for="g in grouped_types" :key="`_group${g.id}`" :label="g.name">
                    <template v-for="t in g.children">
                      <Option :key="`_type${t.id}`" :label="t.path || t.name" :value="t.id">
                        {{t.name}}
                      </Option>
                    </template>
                  </OptionGroup>
                </Select>
              </FormItem>
            </Col>
              <Col :span="7">
              <FormItem required label="名称" prop="name">
                <Input v-model="formData.name" clearable />
              </FormItem>
            </Col>
            <Col :span="7">
              <FormItem required label="型号" prop="model">
                <Input v-model="formData.model" clearable />
              </FormItem>
            </Col>
             <Col :span="6">
              <FormItem label="产地" prop="product_area">
                <Input v-model="formData.product_area" clearable />
              </FormItem>
            </Col>
            <Col :span="18">
              <FormItem label="规格" prop="specification">
                <Input v-model="formData.specification" clearable />
              </FormItem>
            </Col>
          </Row>

           <Row :gutter="20">
            <Col :span="8">
              <FormItem label="生产商" prop="producer_id">
                <div class="flex-line" style="width:100%">
                <Select v-model="formData.producer_id" transfer clearable filterable @on-change="handleSelectCompany">
                  <Option v-for="c in companies" :key="'com_'+c.id" :label="c.name" :value="c.id">
                    <div>{{c.name}}
                      <div style="color:var(--sub-text3);font-size:12px;">{{c.address}}</div>
                    </div>

                  </Option>
                </Select>
                <Button icon="md-add" style="margin-left:10px;flex-shrink:0" @click="showModalCompany=true"></Button>
                </div>
              </FormItem>
            </Col>

           <Col :span="8">
              <FormItem label="品牌" prop="brand_id">
                <div class="flex-line" style="width:100%">
                <Select v-model="formData.brand_id" transfer  clearable filterable>
                  <Option v-for="c in brands" :key="'com_'+c.id" :label="c.name" :value="c.id">
                    <div>{{c.name}}
                      <div style="color:var(--sub-text3);font-size:12px;">{{c.address}}</div>
                    </div>

                  </Option>
                </Select>
                <Button icon="md-add" style="margin-left:10px;flex-shrink:0" @click="showModalBrand=true"></Button>
                </div>
              </FormItem>
            </Col>
            <Col :span="8">
              <FormItem label="系列" prop="series">
                  <AutoComplete :data="series" v-model="formData.series" clearable />
              </FormItem>
            </Col>

          </Row>
              <FormItem label="产品说明" prop="note" >
                <Input type="textarea" :rows="3" v-model="formData.note" clearable />
              </FormItem>
            </Col>
          </Row>
          </BaseSegment>
          <BaseSegment title="询价信息"  desc="请填写询价信息（含税或无税价格填一个即可）" :disabled="true">
            <Row>
              <BaseFlexTable v-model="formData.prices" :columns="priceTableColumns" />
            </Row>
          </BaseSegment>
           <BaseSegment title="附件" desc="产品手册/产品说明/其他附件" :disabled="true">
           <Row :gutter="20">
            <Col :span="24">
                <BaseFlexTable v-model="formData.files" :columns="fileTableColumns">
                   <FileSelector slot="button" style="margin-left:10px"  @change="handleSelectFile" />
                </BaseFlexTable>
            </Col>
            </Row>
            </BaseSegment>
          <div class="flex-wrap flex-right">
          <Button type="primary" style="margin-right:10px" @click="handleSubmit">提交</Button>
						<Button @click="handleCancel">取消</Button>

				</div>


        <Modal v-model="showModalCompany" footer-hide title="新建商家" width="600">
          <FormCreateComany @on-success="handleSuccessAddCompany" @on-cancel="showModalCompany=false" />
        </Modal>


        <Modal v-model="showModalBrand" footer-hide title="新建品牌" width="450">
          <FormCreateBrand
            :company_id="formData.producer_id"
            @on-success="handleSuccessAddBrand" @on-cancel="showModalBrand=false" />
        </Modal>
      </Form>
</template>

<script>
import {mapGetters} from 'vuex';
import FormCreateComany from '@/components/mat/CreateCompany';
import FormCreateBrand from '@/components/mat/CreateBrand';

import FileSelector from '@/components/mat/FileSelector';
import {cloneDeep} from 'lodash';
import GFormImageClip from '@/components/form/ImageClip';
export default {
  data() {
    return {
      formData: {},
      brands: [],
      series: [],
      showModalCompany: false,
      showModalBrand: false,
    };
  },
  components: {FormCreateComany, FormCreateBrand, GFormImageClip, FileSelector},
  props: {
    value: {
      type: Object,
      default: ()=>({}),
    },
  },
  mounted() {
    this.$store.dispatch('mat/getTypes');
    this.$store.dispatch('mat/getCompanies');
  },
  watch: {
    value: {
      handler(v) {
        this.formData = cloneDeep(v);
        if (this.formData.producer_id) {
          this.$api.get(`/mat/companies/${this.formData.producer_id}/brands`).then((res)=>{
            this.brands = res.data.data;
          });

          this.$api.get(`/mat/companies/${this.formData.producer_id}/series`).then((res)=>{
            this.series = res.data.data;
          });
        }
      },
    },
  },
  computed: {
    ...mapGetters('mat', ['companies', 'grouped_types']),
    rules() {
      return {
        type_id: [{required: 'true', message: '类型不可为空'}],
        name: [{required: 'true', message: '名称不可为空'}],
        model: [{required: 'true', message: '型号不可为空'}],
      };
    },
    fileTableColumns() {
      return [{
        name: '序',
        key: 'index',
        control: 'index',
      }, {
        name: '拖',
        key: 'drag',
        control: 'drag',
      }, {
        key: 'type',
        name: '附件类型',
        span: 3,
        align: 'left',
        control: 'AutoComplete',
        option: {
          size: 'small',
          transfer: true,
          data: ['产品手册', '使用说明', '介绍视频'],
          clearable: true,
        },
      }, {
        key: 'name',
        name: '名称',
        span: 6,
        control: 'Input',
        option: {
          size: 'small',
          number: true,
          clearable: true,
        },
      }, {
        key: 'url',
        name: '文件',

        span: 4,
        control: 'BaseFileUpload',
      }];
    },
    priceTableColumns() {
      return [{
        name: '序',
        control: 'index',
      }, {
        name: '拖',
        control: 'drag',
      }, {
        key: 'notax_amount',
        name: '无税价格',
        control: 'Input',
        span: 2,
        option: {
          size: 'small',
          number: true,
          clearable: true,
        },
      }, {
        key: 'amount',
        name: '含税价格',
        control: 'Input',
        span: 2,
        option: {
          size: 'small',
          number: true,
          clearable: true,
        },
      }, {
        key: 'unit',
        name: '单位',
        control: 'Input',
        span: 2,
        option: {

          size: 'small',
          clearable: true,
        },
      }, {
        key: 'with_transfer_fee',
        name: '运费',
        control: 'Checkbox',
        span: 1,
        align: 'center',
        option: {

          size: 'small',
          clearable: true,
        },
      }, {
        key: 'with_install_fee',
        name: '安装',
        control: 'Checkbox',
        span: 1,
        align: 'center',
        option: {

          size: 'small',
          clearable: true,
        },
      }, {
        key: 'taxrate',
        name: '税率(%)',
        span: 2,
        control: 'Input',
        option: {
          size: 'small',
          number: true,
          clearable: true,
        },
      }, {
        key: 'supplier_id',
        name: '供应商',
        span: 2,
        align: 'left',
        control: 'BaseSelect',
        option: {
          size: 'small',
          clearable: true,
          filterable: true,
          valueType: 'object',
          options: this.companies,
        },
      }, {
        key: 'accquired_at',
        name: '询价日期',
        span: 2,
        option: {
          size: 'small',
        },
        control: 'BaseDate',
      }, {
        key: 'type',
        name: '询价方式',
        span: 2,
        control: 'BaseSelect',
        option: {
          size: 'small',
          clearable: true,
          valueType: 'string',
          options: ['电话', '聊天', '询价单', '其他'],
        },
      }, {
        key: 'file',
        name: '附件',
        span: 2,
        control: 'BaseFileUpload',
      }];
    },
  },
  methods: {
    handleSelectFile(files) {
      if (files && files.length > 0) {
        if (!this.formData.files) {
          this.$set(this.formData, 'files', files);
        } else {
          files.forEach((v)=>{
            this.formData.files.push({...v});
          });
        }
      }
    },
    handleSuccessAddCompany(e) {
      this.formData.producer_id = e;
      this.showModalCompany=false;
      this.$store.dispatch('mat/getCompanies');
    },
    handleSuccessAddBrand(e) {
      this.formData.brand_id = e;
      this.showModalBrand=false;
      this.getCompanyBrands();
    },
    getCompanyBrands() {
      this.$api.get(`/mat/companies/${this.formData.producer_id}/brands`).then((res)=>{
        this.brands = res.data.data;
      });
    },
    handleSubmit() {
      this.$emit('on-submit', {...this.formData});
      this.formData = {};
    },
    handleCancel() {
      this.$emit('on-cancel');
    },
    handleSelectCompany(e) {
      if (e) {
        this.$api.get(`/mat/companies/${e.value}/brands`).then((res)=>{
          this.brands = res.data.data;
        });

        this.$api.get(`/mat/companies/${e.value}/series`).then((res)=>{
          this.series = res.data.data;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
